DO.Subscribe(['app:ready'], () => {
  /* eslint-disable no-unused-vars */
  function setup() {
    function offsetHeight() {
      return {
        top: -$(this).outerHeight(),
        left: 0,
      };
    }
    const headerContainer = document.querySelectorAll('.header-container');
    if (headerContainer) {
      let lastScrollTop = 0;
      window.addEventListener(
        'scroll',
        () => {
          const top = window.pageYOffset
                        || document.documentElement.scrollTop;
          const header = document.querySelector('.header');
          if (header) {
            if (top > lastScrollTop) {
              if (
                header.classList.contains('fixed')
                                && top >= 10
              ) {
                header.classList.remove('fixed');
              }
            } else if (
              !header.classList.contains('fixed')
                                && top >= 10
            ) {
              header.classList.add('fixed');
            } else if (top < 10) {
              header.classList.remove('fixed');
            }
            lastScrollTop = top <= 0 ? 0 : top; // For Mobile or negative scrolling
          }
        },
        false,
      );
    }
  }

  /* eslint-disable no-undef */
  function placeheader() {
    header.classList.add('placed');
    header.classList.remove('loaded');
    setup();
  }

  function loaded() {
    const header = document
      .querySelector('.header')
      .classList.add('loaded');

    setTimeout(placeheader.bind(null, header), 1500);
  }
  function init() {
    loaded();
  }

  init();
});
